import * as React from 'react';

function SvgEditLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M4.688 19.776c.053 0 .105-.005.157-.013l4.394-.773a.256.256 0 00.138-.073L20.451 7.805a.262.262 0 000-.37l-4.342-4.359A.258.258 0 0015.924 3a.258.258 0 00-.186.076L4.665 14.188a.266.266 0 00-.073.139l-.77 4.409a.883.883 0 00.867 1.04zM21 21a1 1 0 010 2H3a1 1 0 010-2h18zM15.924 5.7l1.914 1.921-9.474 9.505-2.322.412.407-2.333L15.924 5.7z" />
    </svg>
  );
}

export default SvgEditLine;
